module.exports = __webpack_public_path__ + "static/img/search_btn.b20c75c8.png";